export default "__VITE_ASSET__Dg$uIZ6z__"